import { createRouter, createWebHistory } from 'vue-router'
import LanguageSwitcher from '@/components/LanguageSwitcher'
import Login from '@/pages/Login'
import api from '@/utils/api'
import Register from '@/pages/Register'
import Restore from '@/pages/Restore'
import Recovery from '@/pages/Recovery'
import Cookies from 'js-cookie'

export const routes = [
  {
    path: '/en/:path(.*)?',
    component: LanguageSwitcher,
    props: { functional: true }
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: { guest: true }
  },
  {
    name: 'activate',
    path: '/login/activate/:id',
    component: Login,
    meta: { guest: true }
  },
  {
    name: 'restore',
    path: '/login/restore',
    component: Restore,
    meta: { guest: true }
  },
  {
    name: 'pwrestore',
    path: '/login/restore/:code',
    component: Recovery,
    meta: { guest: true }
  },
  {
    name: 'register',
    path: '/register/:status(ready)?',
    component: Register,
    props: { functional: true },
    meta: { guest: true }
  },
  {
    path: '/',
    name: 'home',
    meta: { guest: false },
    component: () => import('./pages/HomePage.vue')
  },
  {
    name: 'search',
    path: '/search',
    meta: {
      root: '/storage',
      guest: false
    },
    component: () => import('./pages/SearchPage.vue')
  },
  {
    name: 'S3SearchPage',
    path: '/searchS3',
    meta: { root: '/s3' },
    component: () => import('./pages/S3SearchPage.vue')
  },
  {
    name: 'settings',
    path: '/settings/:page([^/]*)?/:section([^/]*)?/:subsection([^/]*)?',
    props: true,
    meta: {
      root: '/settings',
      guest: false
    },
    component: () => import('./pages/SettingsPage.vue')
  },
  {
    name: 'storage',
    path: '/storage/:path(.*)?',
    props: true,
    meta: {
      root: '/storage',
      guest: false
    },
    component: () => import('./pages/StoragePage.vue')
  },
  {
    name: 'dns',
    path: '/dns/:name?',
    props: true,
    meta: { root: '/dns' },
    component: () => import('./pages/DnsPage.vue')
  },
  {
    name: 'streams',
    path: '/streams/:id?',
    props: true,
    meta: { storageRoot: '/storage', guest: false },
    component: () => import('./pages/StreamsPage.vue')
  },
  {
    name: 'tasks',
    path: '/tasks',
    props: true,
    meta: { root: '/tasks', guest: false },
    component: () => import('./pages/TasksPage.vue')
  },
  {
    name: 'feedback',
    path: '/feedback',
    props: true,
    meta: { root: '/feedback', guest: false },
    component: () => import('./pages/FeedbackPage.vue')
  },
  {
    name: 'cdn-stats',
    path: '/cdn-stats',
    props: true,
    meta: { root: '/cdn-stats', guest: false },
    component: () => import('./pages/CdnStatsPage.vue')
  },
  {
    name: 'S3',
    path: '/s3/:bucket?',
    props: true,
    meta: { root: '/s3', guest: false },
    component: () => import('./pages/S3Page.vue')
  },
  {
    name: 'S3-objects',
    path: '/s3/:bucket/:path(.*)?',
    props: true,
    meta: { root: '/s3', guest: false },
    component: () => import('./pages/S3Page.vue')
  },
  {
    name: 'channels',
    path: '/channels',
    props: true,
    meta: { root: '/channels', guest: false },
    component: () => import('./pages/ChannelsPage')
  },
  {
    name: 'channel',
    path: '/channels/:id',
    props: true,
    meta: { root: '/channels', guest: false },
    component: () => import('./pages/ChannelPage')
  },
  {
    path: '/:pathMatch(.*)*', component: () => import('./pages/NotFoundPage.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach(async (to) => {
  const guestRoute = to.meta.guest

  if (to.name === 'login') {
    const tokenRaw = Cookies.get('pc_token')
    if (tokenRaw) {
      try {
        const token = JSON.parse(atob(tokenRaw))
        await api.setToken(token)
        Cookies.remove('pc_token', { path: '/login' })
        return { name: 'home' }
      } catch (err) {
        console.error('SetToken error:', err)
      }
    }
  }

  if (!guestRoute) {
    if (api.token) {
      return true
    }
    try {
      await api.refreshToken()
      return true
    } catch {
      return { name: 'login' }
    }
  }

  return true
})

export default router
